import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/newsData';
import { useTranslation } from 'react-i18next';

// トップページのお知らせは、newsData(手動+自動マージ・日付降順ソート済)の最新5件を動的表示する。
// 残りは「お知らせ一覧を見る」リンクから /news へ誘導する(Yuichi 2026-07-22: トップは最大5件+一覧リンク)。
// 記事コンテンツは日本語のみのため、EN表示でもタイトル/カテゴリは記事の値をそのまま用いる
// (お知らせ一覧/講師ブログと同型のEN扱い)。セクション見出しのみ i18n で切替える。
const TOP_NEWS_COUNT = 5;

export default function NewsSection() {
  const { t } = useTranslation();
  const items = newsArticles.slice(0, TOP_NEWS_COUNT);

  return (
    <section className="relative pt-12 pb-24 md:pt-16 md:pb-32 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="mb-14">
          <div>
            <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-4 font-label">
              NEWS
            </p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 tracking-[0.06em] mb-3">
              {t('home.news.title')}
            </h2>
            <div className="gold-line-left"></div>
          </div>
        </div>

        {/* News List — 広幅1行レイアウト(§17): 日付/カテゴリ左固定 + タイトル1行(折返し0) */}
        <div className="border-t border-background-200">
          {items.map((article) => (
            <Link
              key={article.slug}
              to={`/news/${article.slug}`}
              className="flex flex-col md:flex-row md:items-center gap-8 py-5 border-b border-background-200/80 hover:bg-background-100/50 transition-colors duration-300 group px-2 -mx-2"
            >
              <div className="flex items-center gap-3 md:contents">
              <span className="md:w-[12em] flex-shrink-0 text-[14px] text-foreground-500 tracking-[0.06em] font-label whitespace-nowrap tabular-nums">
                {article.date}
              </span>
              <span className="md:w-[8em] flex-shrink-0">
                <span className="inline-block px-2.5 py-0.5 border border-accent-500/30 text-accent-600 text-[12px] tracking-[0.08em] whitespace-nowrap">
                  {article.categoryLabel}
                </span>
              </span>
              </div>
              <p className="w-full md:flex-1 min-w-0 text-[16px] text-foreground-800 group-hover:text-foreground-900 transition-colors leading-relaxed tracking-[0.03em] md:whitespace-nowrap md:overflow-hidden md:text-ellipsis">
                {article.title}
              </p>
              <i className="ri-arrow-right-s-line hidden sm:block text-accent-400 text-base flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
            </Link>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/news"
            className="btn-glow inline-flex items-center gap-3 px-8 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap"
          >
            {t('home.news.viewAll')}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
